let scroll = window.requestAnimationFrame

const desktopHeader = document.getElementById( 'desktopHeader' )

let scrollPositionY = 0
let scrollThreshold = desktopHeader.offsetHeight + 5


const init = function() {

    if ( window.requestAnimationFrame ) {
        loop()
    }

    setupDelayedGifs()

}

/**
 * This function will force animated gifs to reload as they enter the view
 * port, to appear as if they have loaded for the first time.
 */
const setupDelayedGifs = function() {

    document.addEventListener('DOMContentLoaded', () => {

        const images = document.querySelectorAll('.delayed-gif img');
    
        const observer = new IntersectionObserver((entries) => {
            entries.forEach( entry => {
                
                const img = entry.target
                img.style.opacity = 0

                if (entry.isIntersecting) {

                    // Make sure we have a valid src before proceeding
                    if ( img.src && img.src !== '' ) {
                        
                        img.style.opacity = 1

                        if ( !img.hasAttribute('data-original-src') ) {
                            img.setAttribute( 'data-original-src', img.src );
                        }

                        const baseUrl = img.getAttribute('data-original-src').split('?')[0];
    
                        // Force reload of the image to restart animation
                        img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'; // Tiny transparent GIF

                        const cacheBuster = '?reload=' + new Date().getTime()

                        // Small timeout ensures the browser registers the change
                        setTimeout(() => {
                            img.src = baseUrl + cacheBuster;
                        }, 20 );

                    }

                } else {
                    
                    img.style.opacity = 0

                }

            });
        }, {
            threshold: 0.1
        });
    
        images.forEach(img => {
            observer.observe(img);
        });
    });

}


const loop = function() {
    watchTop()
    scroll( loop )
}


const watchTop = function() {

    // get current scroll position
    const scrollAmount = window.scrollY

    // if it hasn't changed since last scroll, bail now
    if ( scrollPositionY === scrollAmount ) return

    // otherwise, update the main scroll tracking variable
    scrollPositionY = scrollAmount

    // if scroll amount is less than or equal to 0, add top class
    if ( scrollAmount <= 0 ) {
        document.body.classList.add('is-at-top')

    // if scroll amount is greater than 0, remove top class
    } else {
        document.body.classList.remove('is-at-top')
    }

    // if scroll amount is above the scroll threshold, add compression class
    if ( scrollPositionY >= scrollThreshold ) {

        document.body.classList.add( 'is-beyond-scroll-threshold' )

    // if scroll amount is below the scroll threshold, remove compression class
    } else {

        document.body.classList.remove( 'disable-utilities' )

    }

}

const api = {
    init: init
}

export default api;
